import { setStorage, getStorage, removeStorage } from '@/utils/util';
import { SELECTED_DEVICE_ID } from '@/constants/index';
export default {
	namespaced: true,

	state: {
		currentDeviceId: getStorage(SELECTED_DEVICE_ID) || '',
	},

	mutations: {
		setCurrentDeviceId(state, id) {
			state.currentDeviceId = id;
			if (id) {
				setStorage(SELECTED_DEVICE_ID, id);
			} else {
				removeStorage(SELECTED_DEVICE_ID);
			}
		},
	},
};
